// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationGenerator-cls1_FzQ","cls2":"CitationGenerator-cls2_0Gk CitationGenerator-cls1_FzQ"};